export const SPLIT_RECORD_CONSTANTS = {
    action: 'split',
    config: {
        amount: {
            label: 'Valore',
            type: 'number'
        },
        description: {
            label: 'Descrizione',
            type: 'text'
        },
        pianoContiCfId: {
            label: 'Piano dei conti',
            optionId: 'id',
            optionLabel: 'name',
            type: 'select'
        }
    },
    model: 'cashflows/cashflowrecord',
    modelPianoConti: 'cashflows/pianoconticf',
    title: 'SplitRecord',
    wizardObject: 'CashFlowRecord'
}
